module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="page">\r\n    <a href="javascript:;">\r\n        <span class="iconfont icon-cc-left"></span>\r\n    </a>\r\n    <a href="javascript:;" class="active">1</a>\r\n    <a href="javascript:;">2</a>\r\n    <a href="javascript:;">3</a>\r\n    <a href="javascript:;">4</a>\r\n    <a href="javascript:;">5</a>\r\n    <a href="javascript:;">\r\n        <span class="iconfont icon-cc-right"></span>\r\n    </a>\r\n</div>';

}
return __p
}